import { IconHelp, IconUser } from "@tabler/icons-react";
import React from "react";
import { Col, Form, OverlayTrigger, Row, Tooltip } from "react-bootstrap";
import Select from "react-select";
import {
  AREA_ACTIVITY_OPTIONS,
  GENDER_OPTIONS,
  PERSONALITY_OPTIONS,
} from "../AgentsConstants";
import { Controller } from "react-hook-form";

// Componente Step 1: Identidade do Agente
const StepIdentity = React.memo(
  ({ register, watch, setValue, errors, control }) => {
    return (
      <div>
        <div className="d-flex align-items-center mb-4">
          <IconUser className="me-2 text-primary" size={24} />
          <h4 className="mb-0">Identidade do Agente</h4>
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip>Defina quem é seu agente e como ele se comporta</Tooltip>
            }
          >
            <IconHelp
              className="ms-2 text-muted"
              size={16}
              style={{ cursor: "help" }}
            />
          </OverlayTrigger>
        </div>

        <Row>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>Nome do Agente *</Form.Label>
              <Form.Control
                {...register("agentName")}
                placeholder="Ex: Maria Atendimento"
                isInvalid={!!errors.agentName}
              />
              <Form.Control.Feedback type="invalid">
                {errors.agentName?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>Função</Form.Label>
              <Form.Control
                {...register("agentJob")}
                placeholder="Ex: secretária, atendente virtual..."
                isInvalid={!!errors.agentJob}
              />
              <Form.Control.Feedback type="invalid">
                {errors.agentJob?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>Gênero *</Form.Label>
              <Controller
                name="agentGender"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={GENDER_OPTIONS}
                    placeholder="Selecione o gênero..."
                    value={GENDER_OPTIONS.find(
                      (opt) => opt.value === watch("agentGender")
                    )}
                    onChange={(selected) =>
                      setValue("agentGender", selected?.value || "")
                    }
                    className={errors.agentGender ? "is-invalid" : ""}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        minHeight: "56px",
                        borderRadius: "1.25rem",
                        borderColor: errors.agentGender
                          ? "#dc3545"
                          : state.isFocused
                          ? "#86b7fe"
                          : "#dee2e6",
                        boxShadow: state.isFocused
                          ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)"
                          : "none",
                        "&:hover": {
                          borderColor: errors.agentGender
                            ? "#dc3545"
                            : "#b0b8c1",
                        },
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        color: "#6c757d",
                      }),
                    }}
                  />
                )}
              />
              {errors.agentGender && (
                <div className="invalid-feedback d-block">
                  {errors.agentGender?.message}
                </div>
              )}
            </Form.Group>
          </Col>
          <Col md={3}>
            <Form.Group className="mb-3">
              <Form.Label>Área de Atuação *</Form.Label>
              <Controller
                name="agentArea"
                control={control}
                render={({ field }) => (
                  <Select
                    {...field}
                    options={AREA_ACTIVITY_OPTIONS}
                    placeholder="Selecione a área..."
                    isSearchable
                    value={AREA_ACTIVITY_OPTIONS.find(
                      (opt) => opt.value === watch("agentArea")
                    )}
                    onChange={(selected) =>
                      setValue("agentArea", selected?.value || "")
                    }
                    className={errors.agentArea ? "is-invalid" : ""}
                    styles={{
                      control: (provided, state) => ({
                        ...provided,
                        minHeight: "56px",
                        borderRadius: "1.25rem",
                        borderColor: errors.agentArea
                          ? "#dc3545"
                          : state.isFocused
                          ? "#86b7fe"
                          : "#dee2e6",
                        boxShadow: state.isFocused
                          ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)"
                          : "none",
                        "&:hover": {
                          borderColor: errors.agentArea ? "#dc3545" : "#b0b8c1",
                        },
                      }),
                      placeholder: (provided) => ({
                        ...provided,
                        color: "#6c757d",
                      }),
                    }}
                  />
                )}
              />
              {errors.agentArea && (
                <div className="invalid-feedback d-block">
                  {errors.agentArea?.message}
                </div>
              )}
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>
            Personalidade do Agente *
            <OverlayTrigger
              placement="top"
              overlay={
                <Tooltip>É como você descreveria o jeito dela falar</Tooltip>
              }
            >
              <IconHelp
                className="ms-1 text-muted"
                size={14}
                style={{ cursor: "help" }}
              />
            </OverlayTrigger>
          </Form.Label>
          <div className="d-flex flex-wrap gap-2">
            {PERSONALITY_OPTIONS.map((personality) => (
              <Form.Check
                key={personality}
                type="checkbox"
                id={`personality-${personality}`}
                label={personality}
                value={personality}
                {...register("agentPersona")}
                className="me-3"
              />
            ))}
          </div>
          {errors.agentPersona && (
            <div className="text-danger small mt-1">
              {errors.agentPersona.message}
            </div>
          )}
        </Form.Group>
      </div>
    );
  }
);

StepIdentity.displayName = "StepIdentity";

export default StepIdentity;
